import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, unref } from 'vue';
  import { ColumnHeightOutlined } from '@ant-design/icons-vue';
  import { Tooltip, Dropdown, Menu } from 'ant-design-vue';
  import { useTableContext } from '../../hooks/useTableContext';
  import type { TableProps } from 'ant-design-vue/es/table/Table';
  import type { MenuInfo } from 'ant-design-vue/es/menu/src/interface';

  type SizeType = NonNullable<TableProps['size']>;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'size-setting',
  setup(__props) {

  const table = useTableContext();

  const selectedKeysRef = ref<SizeType[]>([unref(table.getProps)?.size || 'large']);

  function handleMenuClick({ key }: MenuInfo & { key: SizeType }) {
    selectedKeysRef.value = [key];
    table.setProps({
      size: key,
    });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tooltip), { placement: "top" }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.settingDens')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Dropdown), {
        placement: "bottom",
        trigger: ['click']
      }, {
        overlay: _withCtx(() => [
          _createVNode(_unref(Menu), {
            selectedKeys: selectedKeysRef.value,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeysRef).value = $event)),
            selectable: "",
            onClick: handleMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Menu).Item, { key: "large" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.settingDensDefault')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Menu).Item, { key: "middle" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.settingDensMiddle')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Menu).Item, { key: "small" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.settingDensSmall')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(ColumnHeightOutlined))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})